/*============================================================================
Ajax to accompany the ajax cart logic for the static cart screen
Plugin Documentation for the corresponding ajax cart - http://shopify.github.io/Timber/#ajax-cart

This does NOT update total quantity updating. This handles detecting if specified
unpermitted quantities of wine bottles are present and hides the corresponding checkout
buttons if they are.

This should be included after the corresponding Ajax cart scripting.
===========*/

// on updating the cart,


var staticCart = (function(){
    //public functions
    let init;

    //private functions
    let checkIfWinePresent, detectIfValidWineQty, getTotalWineBottles, toggleCheckoutVisibility, getCart;

    var cartUpdateCallback;

    //private variables
    let wineIsPresent, invalidWineQuantity, pickUpChecked;

    let unpermittedValuesArray = [5, 7, 8, 9, 10, 11];

    init = function(){
        //debugger; removed by gist
        //Add event listeners
        $('body').on('change', '.cart-table .js-qty__num', function(){
            setTimeout( () => {
                ShopifyAPI.getCart(cartUpdateCallback);
            }, 250);
        });

        $('body').on('click', '.js-qty__adjust', function() {
            setTimeout( () => {
                ShopifyAPI.getCart(cartUpdateCallback);
            }, 250);
        });

        document.querySelector("#is-pickup-checkbox").addEventListener('change', (e) => {
            pickUpChecked = e.target.checked;
            debugger;
            ShopifyAPI.getCart(cartUpdateCallback);
        });


        //set listener one wine change

        //Set up listener for cart change
        ShopifyAPI.getCart(cartUpdateCallback);

        //Initialize callbacks

    }

    cartUpdateCallback = async function(cart){
        let line_items = cart.items;
        let store_products = await fetch('https://bluequail.com/collections/wine/products.json');
        let json_products = await store_products.json();
        let bottles = getTotalWineBottles(json_products, cart.items);
        detectIfInvalidWineQty(bottles);
        toggleCheckoutVisibility();
    }

    checkIfWinePresent = function(){
        wineIsPresent = !!(document.getElementById("wine-present-check"));
    }

    detectIfInvalidWineQty = function(bottles){
        invalidWineQuantity = unpermittedValuesArray.includes(bottles);
    }

    //Array of each type of wine item
    getTotalWineBottles = function(json_products, line_items){
        debugger
        let _bottlesInCart = 0;
        line_items.forEach(i => {
            if (json_products.products.map(r => r.id).includes(i.product_id)){
                _bottlesInCart = _bottlesInCart + i.quantity;
                present = true;
            }
        })
        return _bottlesInCart;
    }

    toggleCheckoutVisibility = function(){
        debugger;
        const checkoutButtons = document.querySelectorAll('.checkout-toggle');
        const invalidatedWineQtyApplied = invalidWineQuantity && !pickUpChecked;
        for(let i = 0; i < checkoutButtons.length; i++){
            checkoutButtons[i].style.display = invalidatedWineQtyApplied ? "none" : "block";
        }
        document.querySelector(".checkout_qty_notice").style.display = invalidatedWineQtyApplied ? "block" : "none";
    }

    return {
        init: init
    }
})();
staticCart.init();